import { lazy, Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'
import { ExternalRedirect } from './components/App/ExternalRedirect'
import { AppLoader } from './components/common/Helpers/AppLoader'
import { GlobalModals } from './components/GlobalModals'
import { HeaderLayout } from './components/HeaderLayout/HeaderLayout'
import { Main } from './Root.styled'
import { publicRoutes } from './router'
import { ResizeContextProvider } from './contexts/resize/ResizeContext'
import { useInitConfig } from './hooks/useInitConfig'
import { B2C_DEPRECATION_URL } from './constants/shutdownNotice'

const StarkexClaims = lazy(() =>
  import('./pages/LegacyRhinoClaims/LegacyRhinoClaims').then((module) => ({
    default: module.StarkexClaims,
  })),
)

export const MainApp = () => {
  useInitConfig()

  return (
    <ResizeContextProvider>
      <Main>
        <HeaderLayout>
          <Suspense fallback={<AppLoader showOnPage source="suspense-mainapp" />}>
            <Routes>
              <Route path={publicRoutes.legacyRhinoClaim} element={<StarkexClaims />} />
              <Route path="*" element={<ExternalRedirect to={B2C_DEPRECATION_URL} />} />
            </Routes>
          </Suspense>
        </HeaderLayout>

        <GlobalModals />
      </Main>
    </ResizeContextProvider>
  )
}
